import React from "react";

import { DismissiblePopup } from "./DismissiblePopup";

import { useCompetencyAgentVisible } from "../hooks/useCompetencyAgentVisible";

import { useAskPerformYardStore } from "../AskPerformYardStore";

export const CompetencyCoachPopup: React.FC = () => {
	const competencyAgentVisible = useCompetencyAgentVisible();
	const isOnCompetencyPage = useAskPerformYardStore((state) => state.isOnCompetencyPage);
	const isOpen = useAskPerformYardStore((state) => state.isOpen);
	const open = useAskPerformYardStore((state) => state.open);

	return (
		<DismissiblePopup
			popupKey="competency-coach"
			enabled={competencyAgentVisible && isOnCompetencyPage && !isOpen}
			title="Want help setting up competencies?"
			action={{ label: "Set up competencies", onClick: open }}
		/>
	);
};

export default CompetencyCoachPopup;
